import React from 'react';
import Landing from './pages/LandingPage/landing'
import About from './pages/AboutPage/about';
import History from './pages/HistoryPage/history';
import Tracks from './pages/TracksPage/tracks';
import Sponsor from './pages/SponsorPage/sponsor';
import Schedule from './pages/SchedulePage/schedule';
import MoreInfo from './pages/MoreInfoPage/moreinfo';
import Footer from './components/Footer/footer';
import FAQ from './pages/FAQPage/faq';
import Keynote from './pages/KeynotePage/keynote'
import Recap from './pages/RecapPage/recap'
import { Main } from './utils/theme'

const App: React.FC = () => {
  return (
    <div className="App">
      <Main>
        <Landing />
        <Recap />
        <About />
        <History />
        <Schedule />
        <Tracks />
        <Keynote />
        <Sponsor />
        <FAQ />
        <MoreInfo />
      </Main>
      <Footer />
    </div>
  );
}

export default App;
